import React, { useEffect, useState } from "react";
import { Col, Row, Radio, Input, Checkbox, Form, Button } from "antd";
// import { getStyleProperties } from "../../../utils/CustomFunc";
import axios from "../../utils/BasicAuthAPI";
import "./exam.css";
import liracrypt from "../Liracrypt/liracrypt";
import ZenFormInput from "../../pages/InputCreater/ZenFormInput";

const ExamZenForm = (props) => {
  const LocalDict = [];
  const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
  const [form] = Form.useForm();

  const onFinish = (values) => {
    let answer = { ...props.questions, minPassMarks: 5 };
    delete answer["questions"];
    delete answer["Data"];
    answer["answers"] = props.questions.questions.map((ques) => {

      return {
        ...ques,
        ans: "A",
        minPassMarks: 5,
        ansGiven:
          values[ques._id] && Array.isArray(values[ques._id])
            ? values[ques._id][0]
            : values[ques._id],
      };
    });

    if (props.submitHandler) {
      props.submitHandler(answer);
    }
  };

  const queryElements = (controls) => {
    return (<Row>
      {
        controls.map((data, index) => {
          if (dtArray.includes(data["typ"])) {

            LocalDict[data["data_index"]] = data["format"]
              ? data["format"]
              : "YYYY-MM-DD hh:mm:ss";
            LocalDict["data_index_from"] = data["data_index_from"];
            LocalDict["data_index_to"] = data["data_index_to"];
          }

          if (data.visible) {
            return (
              <React.Fragment key={index}>
                <ZenFormInput
                  childType={data.childType}
                  header={data.header}
                  footer={data.footer}
                  labelColSpan={data["labelColSpan"]}
                  style={data['style']}
                  height={data['height']}
                  layoutPosition="space-between"
                  form={form}
                  LocalDict={LocalDict}
                  rows={data.rows}
                  colSpan={data.colSize || 12}
                  name={data["data_index"]}
                  label={data["label"]}
                  defaultValue={data["default"]}
                  typ={data["typ"]}
                  disabled={data["readOnly"]}
                  source={data["source"]}
                  sourceParams={data["sourceParams"]}
                  auxParams={data["auxParams"]}
                  format={data["format"]}
                  errorMessage={data["errorMessage"]}
                  placeHolder={data["placeHolder"]}
                  required={data["required"]}
                  options={data["data"]}
                  from={data["data_index_from"]}
                  to={data["data_index_to"]}
                  url={data["url"]}
                  includeAll={data["includeAll"]}
                  pname={data["p_data_index"]}
                  defaultFrom={data["defaultFrom"]}
                  defaultTo={data["defaultTo"]}
                  multiSelect={data["multiSelect"]}
                  searchable={data["isSearchable"]}
                  data={data}
                  extraData={props.extraData}
                  children={data['children']}
                />
              </React.Fragment>
            );
          }
        })}
    </Row>)
  }



  return (
    <React.Fragment>
      {props.questions ? (
        <Col span={24} style={{ padding: "10px 10px" }}>
          <Row
            justify="space-between"
            style={{
              marginBottom: "20px",
              borderBottom: "1px solid #313452",
            }}
          >
            <Col span={8}>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Associate Name :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.questions.eame}
                </span>
              </p>
            </Col>
            <Col span={8}>
              <p style={{ textAlign: "center", fontSize: "22px" }}>
                Skill Category :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.questions["cat"]}
                </span>
              </p>
            </Col>
            <Col span={8}>
              <p style={{ textAlign: "right", fontSize: "22px" }}>
                Skill Level :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.questions["lvl"]}
                </span>
              </p>
            </Col>
          </Row>
        </Col>
      ) : null}
      <div className={'customer-complaint'} style={{ padding: "10px" }}>
        <div className="customer-form">
          <Form
            labelWrap={true}
            layout={props.pageConfig?.config?.layout || "inline"}
            form={form}
            size="large"
            colon={false}
            labelCol={{ span: 8 }}
            name="basic"
            // initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            {
              props.pageConfig?.config?.groupControl ?
                props.pageConfig?.config?.modalElements.map((groupedElement, groupIndex) => (
                  <>
                    <p style={groupedElement.header.style}>{groupedElement.header.text}</p>
                    <div key={groupIndex} className="grouped-zen-form" style={groupedElement.style}>
                      {queryElements(groupedElement.controls)}
                    </div>
                  </>
                )) :
                queryElements(props.pageConfig?.config?.modalElements)
            }
            <Col>
              <Form.Item className="formBtnGroup" label=" " colon={false}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button gx-mt-1 bigBtn"
                >
                  {"Submit"}
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ExamZenForm;
